import React, { FC, useContext, useCallback } from 'react';

import { IRoundGame } from '../../../../../../store/admin/eventRounds/store';
import { GlobalContext } from '../../../../../../store';

import PlayerCard from '../../../../../../components/PlayerCard/PlayerCard';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from '../../Context/TeeSheetCreator.context';

interface IGroupGameProps {
  game: IRoundGame;
  index: number;
}

export const GroupGame: FC<IGroupGameProps> = props => {
  const { game, index } = props;

  const {
    actions: {
      adminEventRounds: { removePlayerFromGroup }
    },
    adminEventRounds: { current: round }
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const {
    actions: { onPlayerSwap }
  } = useTeeSheetCreatorDispatch();

  const { selectedPlayer } = useTeeSheetCreatorState();

  const onRemovePlayer = useCallback(
    (enrollmentId: number) => async () => {
      await removePlayerFromGroup(Number(clubId), Number(eventId), Number(roundId), enrollmentId);
    },
    [clubId, eventId, roundId]
  );

  const player = round
    ? round.enrollments.find(e => !!game && e.id === game.enrollment)
    : undefined;

  return player && round ? (
    <div className="single-row" key={`group-player-${game.id}-${player.id}-${index}`}>
      <PlayerCard
        item={player}
        key={`playerCard-${player.id}`}
        context={{
          onRemovePlayer,
          onSwapPlayer: onPlayerSwap,
          playerIsSelected: selectedPlayer === player.id,
          round,
          swappingInProcess: selectedPlayer > 0
        }}
      />
    </div>
  ) : (
    <></>
  );
};

export default GroupGame;
